import gql from 'graphql-tag';
import history from '../../history';
import showToaster from '../../helpers/showToaster';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';

export function editRider(values) {
  return async (dispatch, getState, { client }) => {
    const mutation = gql`
        
        mutation updateRider(
            $id: ID,
            $firstName: String,
            $lastName: String,
            $email: String,
            $password: String,
            $phoneDialCode: String
            $phoneNumber: String,
            $userStatus: String,
            $isBan: Int
            $phoneCountryCode: String
            $gender: String
            $preferredCurrency: String
            ) {
            updateRider(
              id: $id
              firstName: $firstName
              lastName: $lastName
              email:$email
              password: $password
              phoneDialCode: $phoneDialCode
              phoneNumber: $phoneNumber
              userStatus: $userStatus
              isBan: $isBan
              phoneCountryCode: $phoneCountryCode
              gender: $gender
              preferredCurrency: $preferredCurrency
            )
            {
              status
              errorMessage
            }
          }
        `;
    const query = gql`
        query getAllRiders($currentPage: Int){
            getAllRiders(currentPage: $currentPage){
             count
              userData{
                email
                  phoneNumber
                  userStatus
                  isBan
                    createdAt
                    profile{
                       profileId
                      firstName
                      lastName
                      country
                      gender
                    }
              }
            }
          }
        `;

    dispatch(setLoaderStart('EditRider'));

    const { data } = await client.mutate({
      mutation,
      variables: {
        id: values?.id,
        firstName: values?.firstName,
        lastName: values?.lastName,
        email: values?.email,
        password: values?.password,
        phoneDialCode: values?.phoneDialCode,
        phoneNumber: values?.phoneNumber,
        userStatus: values?.userStatus,
        isBan: values?.isBan,
        phoneCountryCode: values?.phoneCountryCode,
        gender: values?.gender,
        preferredCurrency: values?.preferredCurrency
      },
      refetchQueries: [{
        query,
        variables: {
          currentPage: 1
        }
      }]
    });

    dispatch(setLoaderComplete('EditRider'));

    if (data?.updateRider?.status === 200) {
      history.push('/siteadmin/riders')
      showToaster({ messageId: 'updateRider', toasterType: 'success' })
    } else {
      showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.updateRider?.errorMessage })
    }
  }
}